module.exports = __webpack_public_path__ + "img/mobile_driving.f370f4ac.svg";